export default __webpack_public_path__ + "static/media/type_10_3.30ecf4be.svg";